var search = {
	$this: $( '.search-div' ),
	$input: $( '.search-div' ).find( 'input[name="s"]' ),
	$logo: $( '.js-header .logo' ),
	open: function( e ) {

	},
	init: function() {
		$( '.search-submit button' ).on( 'click', function( e ) {
			e.preventDefault();
			if ( search.$this.hasClass( 'active') || 0 == $('html.mobile').length ) {
				// ... use search
				if ( search.$input.val().length > 2 ) {
					//console.log('ga zoeken!');
					search.$this.find('input[type="submit"]').click();
				}
			} else {
				if ( $('html.mobile').length > 0 ) {
					search.$this.addClass( 'active' );
					search.$logo.css( { 'opacity': 0 } );
				}
			}
		} );
	}
}
